/* eslint-disable arrow-body-style */
/* eslint-disable prefer-template */
import { EXTENSION_STYLE } from "./constant";
import { ConfigType } from "./interface";
import { getMin, yAxisFormat } from "./utils";
import { cloneDeep, findLastIndex, has } from "lodash-es";
import moment from "moment";
import { CHART_TYPE } from "@/pages/dashboard/_config/constant";
import { numFormat, unitConversion } from "@/pages/dashboard/utils/utils";
import { merge } from 'lodash-es';

/**
 * y轴切换最小值展示
 * @param opt option配置项
 * @param _chart echarts实例
 * @param config show 是否显示y轴浮窗
 * @returns
 */
export const changeMin = (opt, _chart, config: ConfigType = {}) => {
  const show = config?.show;
  if (show) {
    opt.yAxis['min'] = 'dataMin';
    opt.yAxis['triggerEvent'] = true;
    opt.yAxis['min'] = (value) => {
      const min = getMin(value);
      return min;
    };
    opt.yAxis.axisLabel = {
      formatter: (value) => {
        let num = yAxisFormat(value);
        if (config.yAxisFormat) num = config.yAxisFormat(value);
        return num;
      }
    };
    showExtension(_chart, config);
  } else {
    opt.yAxis['triggerEvent'] = false;
    opt.yAxis['min'] = 0;
  }
  return opt;
};

/**
 * y轴展示浮窗扩展
 * @param chart echarts实例
 * @returns
 */
export const showExtension = (chart, config: ConfigType = {}) => {
  if (chart === null || chart === undefined) return;
  // opt.yAxis['triggerEvent'] = true y轴添加事件可显示刻度浮窗
  // 判断是否创建过div框,如果创建过就不再创建了
  // 该div用来盛放文本显示内容的，方便对其悬浮位置进行处理
  const elementDiv: HTMLElement = document.getElementById('extension') as HTMLElement;
  if (!elementDiv) {
    const div = document.createElement('div');
    div.setAttribute('id', 'extension');
    div.style.display = 'block';
    const htmlDiv: HTMLElement = document.querySelector('html') as HTMLElement;
    htmlDiv.appendChild(div);
  }
  chart.on('mouseover', function (params) {
    if (params.componentType == 'yAxis') {
      const elementDiv: HTMLElement = document.querySelector('#extension') as HTMLElement;
      const value = Number(params.value.replace(/,/g, ''));
      let num = value;
      if (config?.showFormat) num = config.showFormat(value);
      //设置悬浮文本的位置以及样式
      elementDiv.style.cssText = EXTENSION_STYLE;
      elementDiv.innerHTML = num + '';
      const htmlDiv: HTMLElement = document.querySelector('html') as HTMLElement;
      htmlDiv.onmousemove = function (event) {
        const elementDiv: HTMLElement = document.querySelector('#extension') as HTMLElement;
        const xx = event.pageX - 10;
        const yy = event.pageY + 15;
        elementDiv.style.top = yy + 'px';
        elementDiv.style.left = xx + 'px';
      };
    }
  });
  chart.on('mouseout', function (params) {
    if (params.componentType == 'yAxis') {
      const elementDiv: HTMLElement = document.querySelector('#extension') as HTMLElement;
      elementDiv.style.cssText = 'display:none';
    }
  });
};

/**
 * 获取显示数据标签的下标
 * @param data 数据数组
 * @returns
 */
export const getDataIndexList = (data: Array<any>) => {
  // 从末尾开始倒推6个等距的点
  const indexList: number[] = [];
  // 数据标签的间隔
  const gap = Math.round((data?.length - 1) / 6) || 1; // 避免gap为0时, 数据间隔计算错误
  for (let i = 1;indexList.length < 7;i++) {
    const lastOne = indexList[indexList?.length - 1];
    if (!lastOne) {
      indexList.push(data?.length - 1);
    } else {
      indexList.push(lastOne - gap);
    }
  }
  return indexList;
};

export const getOffset = (value: any, index: number, data: Array<any>, config?: any) => {
  const length = config?.formatNum ? String(config?.formatNum(value))?.length : value?.length;
  const getXOffset = (length) => {
    switch (true) {
      case length <= 3: return 8;
      case length <= 4: return 12;
      case length > 4 && length <= 6: return 14;
      case length > 6 && length <= 8: return 16;
      case length > 8 && length <= 10: return 18;
      case length > 10 && length <= 12: return 20;
      default: return 22;
    }
  };
  const offsetTop = 4;
  // (柱状图少量数据 数据标签不需要偏移)
  // 第一个点向右偏移避免画布小的时候被裁减
  if (index === 0) {
    if (data?.length <= 14) return [0, offsetTop];
    return [getXOffset(length), offsetTop];
  }
  // 最后一个点向左偏移避免画布小的时候被裁减
  if (index === data?.length - 1) {
    if (data?.length <= 14) return [0, offsetTop];
    return [-getXOffset(length), offsetTop];
  }
  return [0, offsetTop];
};

/**
 * 是否显示数据标签
 * @param opt option配置项
 * @param config formatter formatNum  数值显示格式器  show 是否显示数值
 * @param visibleIndex 显示趋势图的下标(默认下标为0，扩展可以是数组)
 * @returns
 */
export const addChartLabel = (opt, config: ConfigType = {}, visibleIndex: number | Array<number> = 0) => {
  const series = opt.series?.map((seriesItem, seriesIndex) => {
    const data = opt.series[seriesIndex]?.data;
    const indexList = getDataIndexList(data);
    // // 从末尾开始倒推6个等距的点
    // const indexList: number[] = []
    // // 数据标签的间隔
    // const gap = Math.round((data?.length - 1) / 6) || 1; // 避免gap为0时, 数据间隔计算错误
    // for (let i = 1; indexList.length < 7; i++) {
    //   const lastOne = indexList[indexList?.length - 1]
    //   if (!lastOne) {
    //     indexList.push(data?.length - 1)
    //   } else {
    //     indexList.push(lastOne - gap)
    //   }
    // }
    // 获取数值标签的偏移量
    const getOffset = (value, index) => {
      const length = config?.formatNum ? String(config?.formatNum(value))?.length : value?.length;
      const getXOffset = (length) => {
        switch (true) {
          case length <= 3: return 8;
          case length <= 4: return 12;
          case length > 4 && length <= 6: return 14;
          case length > 6 && length <= 8: return 16;
          case length > 8 && length <= 10: return 18;
          case length > 10 && length <= 12: return 20;
          default: return 22;
        }
      };
      const offsetTop = 4;
      // (柱状图少量数据 数据标签不需要偏移)
      // 第一个点向右偏移避免画布小的时候被裁减
      if (index === 0) {
        if (seriesItem?.type === 'bar' && data?.length <= 14) return [0, offsetTop];
        return [getXOffset(length), offsetTop];
      }
      // 最后一个点向左偏移避免画布小的时候被裁减
      if (index === data?.length - 1) {
        if (seriesItem?.type === 'bar' && data?.length <= 14) return [0, offsetTop];
        return [-getXOffset(length), offsetTop];
      }
      return [0, offsetTop];
    };
    const seriesData = seriesItem?.data?.map((item, index) => {
      if (typeof item === 'object') return item;
      // 展示数据标签的折线
      const seriesShowBol = Array.isArray(visibleIndex) ? visibleIndex?.includes(seriesIndex) : seriesIndex === visibleIndex;
      // 是否展示数值
      const valueShowBol = config?.show && indexList?.includes(index) && seriesShowBol;
      // 是否是单独的圆点
      const isAloneSymbol = (seriesItem?.data[index - 1] === '' || seriesItem?.data[index - 1] === undefined) &&
        (seriesItem?.data[index + 1] === '' || seriesItem?.data[index + 1] === undefined);
      return {
        value: item,
        label: {
          position: 'top',
          offset: getOffset(item, index),
          ...config,
          show: valueShowBol,
        },
        itemStyle: seriesItem?.type === 'line' ? {
          borderColor: '#fff',
          borderWidth: 1,
          borderType: 'solid',
          opacity: valueShowBol || isAloneSymbol ? 1 : 0
        } : {},
        symbolSize: 10,
        symbol: 'circle'
      };
    });

    return {
      ...seriesItem,
      data: seriesData,
      showAllSymbol: true,
      label: {
        normal: {
          formatter: config.formatter,
        }
      },
    };
  });

  return {
    ...opt,
    series
  };
};

/**
 * Realtime 最大值最小值最新值显示圆点
 * @param opt option配置项
 * @param config formatter formatNum  数值显示格式器  show 是否显示数值
 * @param visibleIndex 显示趋势图的下标
 * @returns
 */
export const addChartSymbol = (opt, config: ConfigType = {}, visibleIndex = 0) => {
  const series = opt.series?.map((seriesItem, seriesIndex) => {
    if (seriesIndex !== visibleIndex) return seriesItem;
    const data = seriesItem?.data || [];
    const dataList = seriesItem?.data?.filter(v => v !== '');
    const newIndex = findLastIndex(data, (item) => item !== '');
    const sortList = dataList?.sort((a, b) => a - b);
    const min = sortList[0];
    const max = sortList[sortList?.length - 1];
    const minIndex = data?.findIndex(item => item === min);
    const maxIndex = data?.findIndex(item => item === max);
    const seriesData = data?.map((item, index) => {
      if (typeof item === 'object') return item;
      const getOffset = (value, index) => {
        const length = config?.formatNum ? String(config?.formatNum(value))?.length : value?.length;
        const getXOffset = (length) => {
          switch (true) {
            case length <= 3: return 8;
            case length <= 4: return 12;
            case length > 4 && length <= 6: return 14;
            case length > 6 && length <= 8: return 16;
            case length > 8 && length <= 10: return 18;
            case length > 10 && length <= 12: return 20;
            default: return 22;
          }
        };
        const offsetTop = 4;
        // 第一个点向右偏移避免画布小的时候被裁减
        if (index === 0) {
          return [getXOffset(length), offsetTop];
        }
        // 最后一个点向左偏移避免画布小的时候被裁减
        if (index === newIndex) {
          return [-getXOffset(length) + 6, offsetTop];
        }
        return [0, offsetTop];
      };
      const showList = config?.showList;
      let show = false;
      if (showList?.includes('min') && item === min && index === minIndex) show = true;
      if (showList?.includes('max') && item === max && index === maxIndex) {
        // 当 maxIndex 不是后24个点的时候, 代表最大值不在最近两个小时内, 并且不重合可以显示
        if (data[newIndex] !== max && (config.todayLength ? maxIndex < config.todayLength - 24 : true)) {
          show = true;
        } else {
          show = false;
        }
      }
      if (showList?.includes('new') && index === newIndex) show = true;
      if (show) {
        return {
          value: item,
          label: {
            position: 'top',
            offset: getOffset(item, index),
            show: true
          },
          symbol: show && seriesIndex === visibleIndex ? 'circle' : 'none'
        };
      }
      return item;
    });
    return {
      ...seriesItem,
      data: seriesData,
      label: {
        normal: {
          formatter: config.formatter,
        }
      },
    };
  });
  return {
    ...opt,
    series
  };
};

/**
 * Realtime 添加最新点雷达图
 * @param opt option配置项
 * @param config formatter formatNum  数值显示格式器
 * @returns
 */
export const addNewRadarSymbol = (opt, config: ConfigType = {},) => {
  const series = cloneDeep(opt?.series);
  const data = series?.[0]?.data || [];
  const newIndex = findLastIndex(data, (item) => item !== '');
  const radarData = data?.map((item, index) => {
    if (index === newIndex) {
      return item;
    }
    return '';
  });

  const radarSymbol = {
    type: 'effectScatter',
    coordinateSystem: 'cartesian2d',
    data: radarData,
    color: '#5086F3',
    symbolSize: 0,
    showEffectOn: 'render',
    rippleEffect: {
      color: '#376AE7',
      number: 3,
      scale: 8,
      // brushType: 'stroke'
    },
    label: {
      normal: {
        formatter: config.formatter,
      }
    },
    hoverAnimation: true,
    itemStyle: {
      normal: {
        color: 'rgba(80,134,243,0.2)',
        shadowBlur: 10,
        shadowColor: '#333'
      }
    },
    zlevel: 19
  };
  series.push(radarSymbol);
  return {
    ...opt,
    series
  };
};

/**
 * Realtime 时间滑块
 * @param opt option配置项
 * @returns
 */
export const DataZoom = (opt) => {
  opt.legend.bottom = 30;
  opt.grid.y2 = 66;
  opt.dataZoom = [
    {
      id: 'dataZoomX',
      type: 'slider',
      xAxisIndex: 0,
      filterMode: 'filter',
      handleSize: 20,
      height: 20,
      borderColor: '#d8dae4',
      backgroundColor: 'transparent',
      showDataShadow: true,
      showDetail: false,
      brushSelect: true,
      moveHandleStyle: {
        opacity: 0
      },
      bottom: 8,
      fillerColor: 'rgba(50, 111, 240, 0.1)',
    }
  ];

  return opt;
};

/**
 * x轴高亮显示刻度
 * @param opt option配置项
 * @param config isRealtime 是否realTime折线图
 * @param config isDateComparison 是否DateComparison折线图
 * @returns
 */
export const xAxisHighLight = (opt, config: ConfigType = { isRealtime: false, isDateComparison: false, symbolSize: 10, fontSize: 10 }) => {
  if (!config?.isRealtime) {
    opt.series = opt.series?.map((seriesItem: any) => {
      if (seriesItem?.type === 'line') {
        const seriesData = seriesItem?.data?.map((item: any, index: any) => {
          if (typeof item === 'object') return item;
          // 是否是单独的圆点
          const isAloneSymbol = (seriesItem?.data[index - 1] === '' || seriesItem?.data[index - 1] === undefined) &&
            (seriesItem?.data[index + 1] === '' || seriesItem?.data[index + 1] === undefined);
          return {
            value: item,
            itemStyle: {
              opacity: isAloneSymbol ? 1 : 0
            },
            symbol: 'circle'
          };
        });
        return {
          ...seriesItem,
          data: seriesData,
          symbolSize: config?.symbolSize || 10,
          emphasis: {
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 1,
              borderType: 'solid',
              opacity: 1
            },
          }
        };
      } else {
        return seriesItem;
      }
    });
  }

  opt.tooltip.axisPointer = {
    ...opt.tooltip.axisPointer,
    z: 0,
    label: {
      show: true,
      // backgroundColor: 'transparent',
      backgroundColor: '#ffffff',
      fontSize: config?.fontSize || 10,
      color: '#3B3D4B',
      fontWeight: 700,
      formatter: (params) => {
        // 上下排列的图表（下方图表不需要展示x轴浮窗）对比分析需要展示
        if (params?.axisIndex > 0 && !config?.isDateComparison) return null;
        return config.formatter ? config.formatter(params) : params.value;
      }
    },
    lineStyle: merge({}, {
      // 颜色设置#9D9EA2
      color: '#9D9EA2',
      width: 1,
      type: 'solid'
    }, config?.lineStyle)
  };
  return opt;
};

/**
 * 卡片趋势图
 * @param opt option配置项
 */
export const getCardChart = (opt, config: ConfigType = {}) => {
  const { timeType = 'Day' } = config;
  opt.yAxis.position = 'right';
  opt.yAxis.splitLine.show = false;
  opt.yAxis.splitNumber = 2;
  opt.xAxis[0].axisTick.show = false;
  opt.xAxis[0].axisLine.show = false;
  opt.xAxis[0].axisLabel.formatter = (param: string) => {
    return timeType === 'Month' ? param?.slice(4, 6) : param?.slice(-2);
  };
  return opt;
};

/**
 * x轴刻度格式化
 * @param opt option配置项
 * @param config
 * @returns
 */
export const xAxisLableFormat = (opt, config: ConfigType = {}) => {
  // 刻度处理
  opt.xAxis[0].axisLabel.formatter = function (value) {
    return config.formatter ? config.formatter(value) : value;
  };
  return opt;
};
/**
 * x轴刻度生成函数
 * @param opt option配置项
 * @param config
 * @returns
 */
export const xAxisIntervalFormat = (opt, config: ConfigType = {}) => {
  // 刻度处理
  opt.xAxis[0].axisLabel.formatter = function (value) {
    return config.formatter ? config.formatter(value) : value;
  };
  const xAxisData = opt?.xAxis[0]?.data;
  const count = xAxisData.length;
  const xSplitNumber = config?.xSplitNumber || 24;
  const defaultInterval = parseInt(((count - 1) / xSplitNumber).toString());
  let differNum = count - defaultInterval * xSplitNumber - 1;
  let preIndex = 0;
  const intervalFormat = (index) => {
    // 小于等于24个点全部展示
    if (count <= xSplitNumber) {
      return true;
    }
    if (index === count - 1) {
      // 遍历完数据重置（防止数据被刷掉）
      differNum = count - defaultInterval * xSplitNumber - 1;
      preIndex = 0;
      return true;
    }
    if (index === 0) {
      return true;
    }
    // 间隔数
    const currentInterval = differNum > 0 ? defaultInterval : defaultInterval - 1;
    if (preIndex + 1 + currentInterval === index) {
      differNum = differNum > 0 ? differNum - 1 : 0;
      preIndex = index;
      return true;
    }
    return false;
  };
  opt.xAxis[0].axisLabel.interval = intervalFormat;
  opt.xAxis[0].axisTick.interval = intervalFormat;
  // realtime 5分钟时间滑块刻度自适应事件
  const _chart = config?.chart || null;
  if (_chart) {
    _chart.on('datazoom', (params: any) => {
      const options = _chart.getOption();
      if (params?.start === 0 && params?.end === 100) {
        options.xAxis[0].axisLabel.interval = intervalFormat;
        options.xAxis[0].axisTick.interval = intervalFormat;
        _chart.setOption(options);
      } else {
        options.xAxis[0].axisLabel.interval = 'auto';
        options.xAxis[0].axisTick.interval = 'auto';
        _chart.setOption(options);
      }
    });
  }
  return opt;
};

/**
 * 趋势对比图圆点处理函数
 * @param opt option配置项
 * @returns
 */
export const lineSeries = (opt, config: ConfigType = {}) => {
  // RealTime国家页面 isAllSolid 最新点增加圆点
  const { isAllSolid = false } = config || {};
  // 折现图 展示24个点
  const xAxisData = opt?.xAxis[0]?.data;
  const count = xAxisData.length;
  const xSplitNumber = config?.xSplitNumber || 24;
  const defaultInterval = parseInt(((count - 1) / xSplitNumber).toString());
  let differNum = count - defaultInterval * xSplitNumber - 1;
  let preIndex = 0;
  const indexList = opt?.series[0]?.data?.map((v: any, index: any) => {
    if (typeof (v) === 'object') {
      if(v?.hideCircle){
        return '';
      }
      return index;
    }
  });
  opt.series = opt.series?.map((item: any, ind: number) => {
    // const newIndex = isAllSolid ? findLastIndex(item?.data, (v: any) => v !== '') : null
    return {
      ...item,
      z: 1 / (ind + 4),
      symbol: (value: any, params: { dataIndex: any; value: any }) => {
        const index = params.dataIndex;
        const symbol = isAllSolid ? 'circle' : ind === 0 ? 'circle' : 'emptyCircle';
        // if (isAllSolid && index === newIndex) {
        //   return 'circle'
        // }
        // 小于等于24个点全部展示
        if (count <= xSplitNumber) {
          return symbol;
        }
        if (index === count - 1) {
          // 遍历完数据重置（防止数据被刷掉）
          differNum = count - defaultInterval * xSplitNumber - 1;
          preIndex = 0;
          return symbol;
        }
        if (index === 0) {
          return symbol;
        }
        // 间隔数
        const currentInterval = differNum > 0 ? defaultInterval : defaultInterval - 1;
        if (preIndex + 1 + currentInterval === index) {
          differNum = differNum > 0 ? differNum - 1 : 0;
          preIndex = index;
          return symbol;
        }
        if (index % 12 === 0) {
          return symbol;
        }
        // if判断是特殊处理, 后期删除, 当满足某些特殊的gameCode的时候, 显示全部的点
        if (config?.gameCode === "wuxia_mobile_kr") return ind === 0 ? 'circle' : 'emptyCircle';
        // 最小值最大值最新值
        if (ind === 0 && indexList?.includes(index)) {
          return 'circle';
        }
        return 'none';
      },
      symbolSize: 6,
      showAllSymbol: true,
      itemStyle: {
        normal: {
          lineStyle: {
            width: 2,
            type: isAllSolid ? 'solid' : ind > 0 ? 'dotted' : 'solid'
          }
        }
      }
    };
  });
  return opt;
};

/**
 * realtime 趋势对比图生成函数
 * @param opt option配置项
 * @param config
 * @returns
 */
export const contrastLine = (opt, config: ConfigType = {}) => {
  opt = lineSeries(opt, config);
  opt = xAxisIntervalFormat(opt, config);
  return opt;
};


export const xAxisLabelFormat = (opt, config: ConfigType = {}) => {
  // x 轴 label 默认格式化函数，默认显示 月-日
  const defaultLabelFormatX = (value: moment.MomentInput) => moment(value).isValid() ? moment(value).format('MM-DD') : value;
  const axisLabelFormat = config?.xAxisLabelFormat || defaultLabelFormatX;
  opt.xAxis = opt.xAxis?.map((item: { axisLabel: any }) => {
    return {
      ...item,
      axisLabel: {
        ...item.axisLabel,
        formatter: axisLabelFormat
      }
    };
  });
  return opt;
};

export const compareTrend = (opt: any) => {
  opt?.series?.forEach((item: any, index: number) => {
    item.z = index === 0 ? 1 : 0;
    if (index !== 0) {
      item.itemStyle = {
        normal: {
          lineStyle: {
            width: 2,
            type: 'dotted'
          }
        }
      };
    }
  });
  return opt;
};

// 根据图表类型格式化数据
export const formatDataByChartType = (chartType: 'pie' | 'bar' | 'line' | 'table', options: any, config: any = {}, isCompare = false) => {
  const { BAR, LINE, PIE, TABLE } = CHART_TYPE;
  const formatMap: any = {
    [BAR]: () => {
      const { subTitle } = config;
      // 数据配置
      const seriesBase = {
        type: 'bar',
        barMaxWidth: 80,
        cursor: 'pointer',
      };
      // 图例
      const legend: string[] = [];
      const yAxis = {};
      const series: {
        [ket: string]: any;
      } = [];
      let xAxisData: string[] = [];


      options?.forEach?.((option, index) => {
        const { name = '', data = [], type = 'bar', stack, barCategoryGap } = option;
        legend.push(name ?? '');

        // 只初始化一次横坐标
        if (xAxisData?.length <= 0) {
          xAxisData = data?.map(item => item.x || '');
        }

        let temp = {
          ...seriesBase,
          name,
          type,
          // symbol:'circle',

          // SymbolSize
          // showSymbol: false,
          data: data?.map(item => item.y || '')
        } as any;

        if (chartType === 'bar') {
          temp.stack = stack;
          if (barCategoryGap) temp.barCategoryGap = barCategoryGap;
        }

        if (chartType === 'line' && isCompare) {
          const flag = index % 2 === 0;
          // 保证当前日期在上层
          temp.z = flag ? options?.length + index : index;
          temp.lineStyle = {
            type: flag ? 'solid' : 'dotted'
          };
        }
        series.push(temp);
      });
      return {
        legend,
        series,
        xAxisData,
        yAxis,
        subTitle
      };
    },
    [LINE]: () => {
      const { subTitle } = config;
      const lineOption = formatMap[BAR]();
      return {
        ...lineOption,
        series: lineOption?.series?.map(item => ({
          ...item,
          type: 'line'
        })),
        subTitle
      };
    },
    [TABLE]: () => {
      const { subTitle } = config;

      return {
        ...(options || {}),
        subTitle
      };
    },
    [PIE]: () => {
      const {
        isLastDay = false,
        isSort = false,
        subTitle,
        chartData: chartDataProps,
        legendData: legendDataProps
      } = config as any;
      let legendData: string[] = [];
      const chartData: Array<{
        name: string;
        value: string;
      }> = [];
      // let subTitle: string = ''
      options?.forEach?.(option => {
        const { name = '', data = [] } = option;

        // 若当前数据不能叠加则取最后的数据
        const value = (() => {
          if (isLastDay) {
            // if (!subTitle) subTitle = data[data?.length - 1]?.x

            return data[data?.length - 1]?.y || '';
          } else 
          // if (!subTitle) subTitle = data[0]?.x + '~' + data[data.length - 1]?.x
            return data?.map(item => ((item.y as any) / 1))?.reduce((current, next) => current + next, 0);
        })();

        legendData.push(name);
        chartData.push({
          name,
          value: String(value)
        });
      });

      const newChartData = chartDataProps ?? chartData;
      // 增加数据排序功能
      if (isSort && newChartData.some(v => v.value)) {
        newChartData.sort((a, b) => Number(String(b.value).replace(/,|-|%|/g, '')) - Number(String(a.value).replace(/,|-|%|/g, '')));
        legendData = newChartData.map(v => v.name).filter(v => v !== 'Others');
        newChartData.findIndex(v => v.name === 'Others') > -1 && legendData.push('Others');
      }

      return {
        legendData: legendDataProps ?? legendData,
        chartData: newChartData.some(v => v.value) ? newChartData : [],
        subTitle
      };
    },
  };

  return formatMap[chartType]();
};

//   对纵坐标和横坐标的展示做处理
export const formatxAxisAndyAxis = (opt: any,timeType: string, xAxisLabelFormat?: any, yAxisLabelFormat?: any) => {
  // x 轴 label 默认格式化函数，默认显示 月-日
  const defaultLabelFormatX = (value: any) => (
    // eslint-disable-next-line no-nested-ternary
    (timeType === 'Month' && moment(value).isValid()) ? moment(value).format('YYYY-MM') :
      (moment(value).isValid() ? moment(value).format('MM-DD') : value)
  );

  const axisLabelFormat = xAxisLabelFormat || defaultLabelFormatX;
  // y 轴 label 默认格式化函数
  const defaultLabelFormaty = (value: any) => {
    const formatLabel = value ? unitConversion(value, true) : value;
    const num = value < 1 && value > 0 ? parseFloat(value.toFixed(3)) : formatLabel;
    return num;
  };
  const yaxisLabelFormat = yAxisLabelFormat || defaultLabelFormaty;

  opt.yAxis.axisLabel.formatter = yaxisLabelFormat;
  opt.xAxis = opt.xAxis?.map(item => {
    return {
      ...item,
      axisLabel: {
        ...item.axisLabel,
        formatter: axisLabelFormat
      }
    };
  });
  return opt;
};

export const  testMinValue = (option:any,diff:number) =>{
  return  option.series = option?.series?.map((item:any)=>{
    return {
      ...item,
      data:item?.data.map(items=>{
        const hasValue = has(items, 'value');
        return hasValue ? {
          ...items,
          value: items.value * diff
        }: items * diff;
      })
    };
  });
};


//   对纵坐标和横坐标的展示做处理：分为数字和百分比
export const formatyAxisSmallerThanOne = (opt: any, isPercent?: boolean) => {
  opt.yAxis.max = (value: any) => {
    // if (!isPercent && value?.max >= 0 && value?.max <= 1) {
    //   return 10
    // }
    if (isPercent && value?.max > 0 && value?.max <= 0.001) {
      return 0.001;
    }
    if (isPercent && value?.max > 0.001 && value?.max <= 0.01) {
      return 0.01;
    }
    // 不是最小值范围的时候，不展示max
    // return value?.max
  };
  return opt;
};

/**
 * 堆积图增加数据标签（汇总值）
 * @param option  option配置项
 * @param config  formatNum  数值显示格式器  show 是否显示数值
 * @returns
 */
export const addBarChartLabel = (option: any, config?: any,) => {
  const { formatNum, show = true, seriesData: propSeriesData } = config || {};
  const stackName = 'Total';
  const seriesData: any = propSeriesData ? propSeriesData : [];
  // 生成需要计算的堆积数据 可外部传入需要汇总的数据
  if (!propSeriesData) {
    option.series.map((series: { stack: any; type: string; data: any; name: string | number }) => {
      if (series?.type === 'bar' && series.data) {
        // 将需要汇总的stack设置相同才会堆积
        if (series.stack) series.stack = stackName;
        seriesData?.push(series.data);
      }
    });
  }
  // 生成一个series用来展示堆积汇总值
  if (seriesData && seriesData.length > 0 && seriesData[0]) {
    const totalData = Array.from({ length: seriesData?.[0]?.length || 0 }, () => 0) || 0;
    for (const data of seriesData) {
      for (let i = 0;i < data.length;i++) {
        totalData[i] += parseFloat(data[i] || 0);
      }
    }
    const newFormattedTotalData = totalData.map(data => formatNum ? formatNum(data) : numFormat(data.toFixed(0)));
    const indexList = getDataIndexList(totalData);
    const newData = newFormattedTotalData?.map((item, index) => {
      return {
        value: 0,
        label: {
          offset: getOffset(item, index, newFormattedTotalData),
        },
      };
    });
    option.series.push({
      name: stackName,
      type: 'bar',
      stack: stackName,
      cursor: 'pointer',
      color: '#fff',
      barGap: '-100%',
      data: newData,
      label: {
        show: show,
        position: 'top',
        color: '#525464',
        formatter: (params: any) => {
          if (indexList.includes(params.dataIndex) && totalData[params.dataIndex] > 0) {
            return newFormattedTotalData[params.dataIndex];
          }
          return '';
        },
      },
    });

  }
  return option;
};
